// extracted by mini-css-extract-plugin
export default {"mainItem":"TermsOfUse_mainItem__IMw8V"};